import { ICoords } from '../common/coords.types';
import { UUID, UUID_NULL } from '../common/uuid.types';
import { getEmptyIStopAddress, IStopAddress } from './stop-address.model';

export interface IStopBasic {
  id: UUID;
  position: number;
  status: EStopStatus;
  type: EStopType;
  since: Date | undefined;
  until: Date | undefined;
  address: IAddress;
}

export interface IStopDetail extends IStopBasic {
  freightId: UUID;
  goodsDescription?: string; // content cargo description
  reference?: string;
  arrivedAt?: Date; // => Use to calculate 'status'
  departedAt?: Date; // => Use to calculate 'status'
  netWeight?: number; // only in LOAD stop ¿?
  packages?: number; // only in LOAD stop ¿?
  unloadedNetWeight?: number; // only in UNLOAD stop
  unloadedPackages?: number; // only in UNLOAD stop
  arrivalDriverAppPoint?: ICoords; // start and finish, same coords
  arrivalTruckPoint?: ICoords; // start and finish, same coords
  reservations?: string;
  acceptanceDriverAppPoint?: ICoords;
  acceptanceTruckPoint?: ICoords;
  acceptanceSignatureImage?: string;
  acceptanceName?: string;
  acceptanceTaxId?: string;
  acceptanceAcceptedAt?: Date;
  sealNumber?: string;
  instructions?: string;
}

export interface IAddress {
  companyName?: string; // New, display in address component. Get this value in mapper.
  street: string;
  extraLine?: string;
  city: string;
  postalCode: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  coords?: ICoords;

  phone?: string;
  taxId?: string;

  id?: number | string; // addressBookId
}

// TODO move outside, to stop.enum.ts
export enum EStopType {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  UNLOAD_LOAD = 'UNLOAD_LOAD',
  // SWAP = 'SWAP',
}

// TODO move outside, to stop.enum.ts
export enum EStopStatus {
  UNSTARTED = 'UNSTARTED',
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
}

export function getEmptyDefaultAddress(): IAddress {
  const address: IAddress = {
    companyName: '',
    street: '',
    city: '',
    postalCode: '',
    state: '',
    stateCode: '',
    country: '',
    countryCode: '',
  };

  return address;
}

export function getEmptyStopDetail(): IStopDetail {
  const stop: IStopDetail = {
    freightId: UUID_NULL,
    id: '',
    position: 0,
    status: EStopStatus.UNSTARTED,
    type: EStopType.LOAD,
    since: undefined,
    until: undefined,
    address: getEmptyDefaultAddress(),
  };

  return stop;
}

//// from ionic

export interface IStopBasicForCarrier {
  id: UUID;
  position: number;
  type: EStopType;
  since: Date | null;
  until: Date | null;
  status: EStopStatus; // comes from stopStatus, if arrivedAt and departedAt are provided, it can be calculated
  // arrivedAt?: Date; // TODO for now the data is not available
  // departedAt?: Date; // TODO for now the data is not available
  address: IStopAddress;
}

export interface IStopDetailedForCarrier extends IStopBasicForCarrier {
  goodsDescription?: string;
  reference?: string;
  arrivedAt?: Date;
  departedAt?: Date;
  netWeight?: number; // only in LOAD stop
  packages?: number; // only in LOAD stop
  unloadedNetWeight?: number; // only in UNLOAD stop
  unloadedPackages?: number; // only in UNLOAD stop
  arrivalDriverAppPoint?: ICoords; // start and finish, same coords
  arrivalTruckPoint?: ICoords; // start and finish, same coords
  reservations?: string;
  acceptanceDriverAppPoint?: ICoords;
  acceptanceTruckPoint?: ICoords;
  acceptanceSignatureImage?: string;
  acceptanceName?: string;
  acceptanceTaxId?: string;
  acceptanceAcceptedAt?: Date;
  sealNumber?: string;
  instructions?: string;
}

// from DTO VerifyFreightStopGoodsInfoCommand
export interface IStopGoodsInfo {
  stopId: UUID;
  tare: number | null; // modified because a null is being sent
  grossWeight: number | null; // modified because a null is being sent
  netWeight: number;
  packages: number;
  unloadedNetWeight: number;
  unloadedPackages: number;
  goodsDescription: string;
  reservations: string;
  sealNumber: string;
  freightId: UUID;
}

//// from shippers

export interface IStopBasicForShipper {
  id: UUID;
  position: number;
  type: EStopType; // enum, comes from FreightStopType
  since: Date | null;
  until: Date | null;

  // arrivedAt?: Date; // TODO new, not for now
  // departedAt?: Date; // TODO new, not for now

  // TODO calculate these with arrivedAt and departedAt
  status: EStopStatus; // comes from stopStatus

  // map this with street, city, postalCode, stateCode, countryCode, companyName
  address: IStopAddress;
}

export interface IStopDetailedForShipper extends IStopBasicForShipper {
  // freightId: UUID;
  goodsDescription?: string; // content cargo description
  reference?: string;
  arrivedAt?: Date; // => Use to calculate 'status'
  departedAt?: Date; // => Use to calculate 'status'
  netWeight?: number; // only in LOAD stop ¿?
  packages?: number; // only in LOAD stop ¿?
  unloadedNetWeight?: number; // only in UNLOAD stop
  unloadedPackages?: number; // only in UNLOAD stop
  arrivalDriverAppPoint?: ICoords; // start and finish, same coords
  arrivalTruckPoint?: ICoords; // start and finish, same coords
  reservations?: string;
  acceptanceDriverAppPoint?: ICoords;
  acceptanceTruckPoint?: ICoords;
  acceptanceSignatureImage?: string;
  acceptanceName?: string;
  acceptanceTaxId?: string;
  acceptanceAcceptedAt?: Date;
  sealNumber?: string;

  instructions?: string;
}

export function getEmptyStopDetailedForShipper(): IStopDetailedForShipper {
  const stop: IStopDetailedForShipper = {
    id: '',
    position: 0,
    type: EStopType.LOAD,
    since: null,
    until: null,
    status: EStopStatus.UNSTARTED,
    address: getEmptyIStopAddress(),
  };

  return stop;
}
